if (typeof window !== 'undefined') {
  window.KROWN = window.KROWN || {};

  window.KROWN.quantityRules = window.KROWN.quantityRules || {
    parseIncrements(rawIncrements) {
      if (!rawIncrements || typeof rawIncrements !== 'string') {
        return [];
      }

      return rawIncrements
        .split(',')
        .map((value) => parseInt(String(value).trim(), 10))
        .filter((value) => Number.isInteger(value) && value > 0);
    },

    normalizeQuantity(rawQuantity) {
      const parsed = parseInt(String(rawQuantity), 10);
      return Number.isInteger(parsed) && parsed >= 0 ? parsed : null;
    },

    isValidQuantityForIncrements(rawQuantity, rawIncrements) {
      const increments = this.parseIncrements(rawIncrements);
      const quantity = this.normalizeQuantity(rawQuantity);

      if (!increments.length || quantity === null) {
        return true;
      }

      if (quantity === 0) {
        return true;
      }

      return increments.some((increment) => quantity % increment === 0);
    },

    getInvalidQuantityMessage(rawIncrements) {
      const increments = this.parseIncrements(rawIncrements);
      if (!increments.length) {
        return 'Please enter a valid quantity.';
      }

      return `This product is now sold out. The quantity in your cart has been updated to the available amount.`;
    },

    isQuantityWithinAvailableInventory(rawQuantity, inventoryQuantity) {
      if (inventoryQuantity === null || inventoryQuantity === undefined) {
        return true;
      }
      const quantity = this.normalizeQuantity(rawQuantity);
      if (quantity === null) {
        return true;
      }
      return quantity <= inventoryQuantity;
    },

    getExceedsInventoryMessage() {
      return 'Not enough quantity of this item to add more to your cart.';
    },
  };
}
